import { render, staticRenderFns } from "./zuzhuangMb.vue?vue&type=template&id=3738bbb4&scoped=true&"
import script from "./zuzhuangMb.vue?vue&type=script&lang=js&"
export * from "./zuzhuangMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738bbb4",
  null
  
)

export default component.exports